"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Minicourse = function Minicourse(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "MinicourseTitle MinicourseDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "MinicourseTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "MinicourseDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M29.564 27.609H2.667c-1.599 0-2.41-.817-2.41-2.427V6.142c0-.933.904-.933 1.2-.933h29.345c.57 0 .94.366.94.933v18.916c0 2.08-1.84 2.55-2.178 2.55zM1.13 6.747v18.435c0 1.436.793 1.556 1.538 1.556H29.53c.223-.04 1.342-.311 1.342-1.68V6.836c-1.255 1.08-4.096 3.524-6.94 5.968-7.738 6.65-7.742 6.653-7.936 6.646-.208-.003-.21-.003-14.866-12.703zm.56-.667c4.791 4.15 12.769 11.056 14.316 12.37 1.557-1.315 9.61-8.24 14.409-12.37H1.69z",
    stroke: "#414C55",
    strokeWidth: ".4"
  }));
};

Minicourse.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Minicourse.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Minicourse;
exports["default"] = _default;